import { useTranslation } from 'react-i18next';
import IconButton from '@lib/components/IconButton/IconButton';
import Tooltip from '@lib/components/Tooltip/Tooltip';
import styles from './RegenerateCodeButton.module.scss';

interface RegenerateCodeButtonProps {
  onClick?: () => void;
  isLoading?: boolean;
}

export default function RegenerateCodeButton({
  onClick,
  isLoading,
}: RegenerateCodeButtonProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <Tooltip body={t('regenerate-code')}>
        <IconButton
          icon="autorenew"
          onClick={onClick}
          isLoading={isLoading}
          disabled={isLoading}
        />
      </Tooltip>
    </div>
  );
}
